import { ImpersonationBanner } from '@/support/ImpersonationBanner';
import { readCsrfToken, readImpersonation } from '@/support/session';

export default function ImpersonationWarning() {
  const session = readImpersonation();
  return session ? <ImpersonationBanner {...session} csrfToken={readCsrfToken()} /> : null;
}
